import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17307_1382)">
        <path
          d="M15.1135 10.7779H10.4468V15.4446H8.89128V10.7779H4.22461V9.22233H8.89128V4.55566H10.4468V9.22233H15.1135V10.7779Z"
          [attr.fill]="'currentColor'"
        />
      </g>
      <defs>
        <clipPath id="clip0_17307_1382">
          <rect
            width="18.6667"
            height="18.6667"
            [attr.fill]="'currentColor'"
            transform="translate(0.333984 0.666504)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlusIconComponent {
  @Input() width = 19;
  @Input() height = 20;
}
